import CenterWrapper from "Components/CenterWrapper";
import SendUsStoryForm from "./SendUsStoryForm";
import SendUsStorySuccess from "./SendUsStorySuccess";
import { useState } from 'react'




const SendUsStory = () => {
const [success, setSuccess]= useState(false)

  return (
    <CenterWrapper>
     {success ? <SendUsStorySuccess/>: <SendUsStoryForm setSuccess={setSuccess}/>}
    </CenterWrapper>
  );
};

export default SendUsStory;
